// src/utils/apiClient.js
import axios from "axios";

const createApiClient = (baseURL = process.env.REACT_APP_POCAS_BASE_URL) => {
  const instance = axios.create({
    baseURL: baseURL || "",
    timeout: 5 * 60 * 1000, // default 5 minutes for uploads
    headers: {
      "Accept": "application/json",
    },
    withCredentials: false,
  });

  instance.interceptors.request.use((config) => {
    if (!config.headers?.Authorization) {
      const token = localStorage.getItem("authToken");
      if (token) config.headers = { ...config.headers, Authorization: token };
    }
    return config;
  }, (err) => Promise.reject(err));

  instance.interceptors.response.use((res) => res, (error) => {
    let normalized = {
      message: "An unexpected error occurred",
      code: "UNKNOWN_ERROR",
      status: error?.response?.status,
      details: null,
    };

    if (error?.response?.data) {
      const data = error.response.data;
      normalized.message = data.message || data.error?.message || JSON.stringify(data);
      normalized.code = data.code || normalized.code;
      normalized.details = data;
    } else if (error?.message) {
      normalized.message = error.message;
    }

    return Promise.reject(normalized);
  });

  return instance;
};

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_POCAS_BASE_URL,
  timeout: 60000,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken") || localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const createCustomApiClient = (opts = {}) => {
  const base = opts.baseURL || process.env.REACT_APP_POCAS_BASE_URL || "";
  const client = createApiClient(base);
  if (opts.timeout) client.defaults.timeout = opts.timeout;
  return client;
};
